import { render, staticRenderFns } from "./menusAllocation.vue?vue&type=template&id=0a502084&scoped=true&"
import script from "./menusAllocation.vue?vue&type=script&lang=js&"
export * from "./menusAllocation.vue?vue&type=script&lang=js&"
import style0 from "./menusAllocation.vue?vue&type=style&index=0&id=0a502084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a502084",
  null
  
)

export default component.exports